module.exports = __webpack_public_path__ + "static/media/twitterDinamic.33e9dd08.gif";